import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-radio-button-input',
  templateUrl: './radio-button-input.component.html',
  styleUrls: ['./radio-button-input.component.scss'],
  standalone: true,
  imports: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioButtonInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class RadioButtonInputComponent implements ControlValueAccessor, AfterViewInit {
  @ViewChild('inputEl') private inputEl?: ElementRef<HTMLInputElement>;

  @Input() controlId: string | null = null;
  @Input() value: any;
  @Input() name: string | null = null;
  @Input() disabled = false;
  @Output() selectionChange = new EventEmitter<any>();

  public generatedRandomId = `radio-${Math.random().toString(36).slice(2)}`;

  public formDisabled = false;
  private modelValue: any;

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  ngAfterViewInit(): void {
    if (this.inputEl) {
      this.inputEl.nativeElement.checked = this.value === this.modelValue;
    }
  }

  writeValue(value: any): void {
    this.modelValue = value;
    if (this.inputEl) {
      this.inputEl.nativeElement.checked = this.value === this.modelValue;
    }
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.formDisabled = isDisabled;
  }

  onInputChange(): void {
    if (!this.disabled && !this.formDisabled) {
      this.onChange(this.value);
      this.onTouched();
      this.selectionChange.emit(this.value);
    }
  }
}
